// Fragment "Global Learn & Telehealth" — merged into ./index.js.
// Convention: flat dotted keys, values in the 3 languages, never empty.
// Backs super_admin/GlobalLearnTelehealth.jsx (tenant link, room when block, timing chip, join
// status) and the Tenant 360 not-found panel. The older glt.* titles live in ./base.js.
export default {
  fr: {
    "glt.tenantMissing": "Ce cabinet n'existe plus — {id}",
    "glt.emptyPublished.banner": "{n} cours publié(s) sans leçon : ils ne peuvent pas être achetés.",
    "glt.emptyPublished.badge": "Publié sans leçon",
    "glt.coursesTruncated": "Affichage des {shown} cours les plus récents sur {total}.",
    "glt.room.scheduledFor": "Prévue le",
    "glt.room.noSchedule": "Aucune date prévue",
    "glt.room.createdOn": "Créée le",
    "glt.timing.upcoming": "À venir",
    "glt.timing.in_progress": "En cours",
    "glt.timing.past": "Passée",
    "glt.join.ready": "Lien de connexion prêt",
    "glt.join.missing": "Aucun lien de connexion valide",
    "glt.join.missingHint": "L'ouverture de la consultation crée une nouvelle salle.",
    "glt.lane.legacy": "Salle héritée",
    "t360.notFound.title": "Cabinet introuvable",
    "t360.notFound.body": "Aucun cabinet ne correspond à l'identifiant {id}. Il a peut-être été supprimé.",
  },
  en: {
    "glt.tenantMissing": "Practice no longer exists — {id}",
    "glt.emptyPublished.banner": "{n} published course(s) have no lessons and cannot be bought.",
    "glt.emptyPublished.badge": "Published with no lessons",
    "glt.coursesTruncated": "Showing the {shown} most recent of {total} courses.",
    "glt.room.scheduledFor": "Scheduled for",
    "glt.room.noSchedule": "No scheduled time",
    "glt.room.createdOn": "Created",
    "glt.timing.upcoming": "Upcoming",
    "glt.timing.in_progress": "In progress",
    "glt.timing.past": "Past",
    "glt.join.ready": "Join link ready",
    "glt.join.missing": "No working join link",
    "glt.join.missingHint": "Opening the consultation creates a new room.",
    "glt.lane.legacy": "Legacy room",
    "t360.notFound.title": "Practice not found",
    "t360.notFound.body": "No practice matches the id {id}. It may have been deleted.",
  },
  es: {
    "glt.tenantMissing": "Esta consulta ya no existe — {id}",
    "glt.emptyPublished.banner": "{n} curso(s) publicado(s) sin lecciones: no se pueden comprar.",
    "glt.emptyPublished.badge": "Publicado sin lecciones",
    "glt.coursesTruncated": "Se muestran los {shown} cursos más recientes de {total}.",
    "glt.room.scheduledFor": "Programada para el",
    "glt.room.noSchedule": "Sin fecha programada",
    "glt.room.createdOn": "Creada el",
    "glt.timing.upcoming": "Próxima",
    "glt.timing.in_progress": "En curso",
    "glt.timing.past": "Pasada",
    "glt.join.ready": "Enlace de acceso listo",
    "glt.join.missing": "Sin enlace de acceso válido",
    "glt.join.missingHint": "Al abrir la consulta se crea una sala nueva.",
    "glt.lane.legacy": "Sala heredada",
    "t360.notFound.title": "Consulta no encontrada",
    "t360.notFound.body": "Ninguna consulta coincide con el id {id}. Es posible que se haya eliminado.",
  },
};
